var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{'in-dev-mode' : _vm.inDevMode}},[(_vm.startVideo)?_c('Player',{attrs:{"startVideo":_vm.startVideo}},[_c('Modals'),_c('Nodes')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }